module.exports = function () { /* empty */ };



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
 ** module id = 907
 ** module chunks = 0
 **/